import type { PaymentMethodPayload } from 'braintree-web-drop-in';

interface CreditCardDetails {
  cardholderName: string;
}

interface PayPalAccountDetails {
  email: string;
  firstName: string;
  lastName: string;
}

interface VenmoAccountDetails {
  username: string;
}
/*
 * other                    : 0
 * credit card              : 1
 * cash/check               : 2
 * venmo                    : 3
 * Refund for participant   : 4
 * zelle                    : 5
 * wire_transfer            : 6
 * Google Pay               : 7
 * Paypal                   : 8
 * Apple Pay                : 9
 */

export const getPaymentMethodDetails = (
  selectedPayment: PaymentMethodPayload,
  isConsentGiven = false
) => {
  const methodType = selectedPayment.type;
  const { details } = selectedPayment;

  if (methodType === 'CreditCard') {
    return {
      cardholderName: (details as CreditCardDetails).cardholderName,
      paymentMethod: 'credit_card',
      vaulted: selectedPayment.vaulted ?? false,
      paymentMethodValue: 1,
    };
  }

  if (methodType === 'PayPalAccount') {
    return {
      paypalEmail: (details as PayPalAccountDetails).email,
      paypalPayerName: `${(details as PayPalAccountDetails).firstName} ${
        (details as PayPalAccountDetails).lastName
      }`,
      paymentMethod: 'paypal_account',
      vaulted: isConsentGiven,
      paymentMethodValue: 8,
    };
  }

  if (methodType === 'VenmoAccount') {
    return {
      venmoUsername: (details as VenmoAccountDetails).username,
      paymentMethod: 'venmo_account',
      vaulted: isConsentGiven,
      paymentMethodValue: 3,
    };
  }

  if (methodType === 'AndroidPayCard') {
    return {
      paymentMethod: 'android_pay_card',
      vaulted: isConsentGiven,
      paymentMethodValue: 7,
    };
  }

  return {};
};

/**
 * Split payment API error message into primary and secondary text using newline.
 *
 * @param message - payment API error message
 */
export const splitPaymentApiErrorMessage = (message: string) => {
  const [primaryText = '', ...secondaryParts] = message.split(/\r?\n/);
  const secondarytText = secondaryParts.join(' ').trim();

  return {
    primaryText: primaryText.trim(),
    secondarytText,
  };
};
